import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { useContributionsPageState } from '#src/app/pages/accountSettings/contributions/main/pageContext';

type Result = ModelHookResult<
	{
		userName: string;
		nameErrorMessage: string | undefined;
		label: string;
		placeholder: string;
	},
	{
		setUserName: (name: string) => void;
		focusNameInput: () => void;
	}
>;

export function useNameInput(): Result {
	const track = useTracking();
	const { translate } = useI18n();

	const [{ userName, nameErrorMessage, selectedPaymentType }, { setUserName }] = useContributionsPageState();

	const focusNameInput = () => {
		void track('sponsor_cc_update_focus_name');
	};

	const label = useMemo(() => {
		if (selectedPaymentType === 'creditCard') return translate('fe.components.credit_card.cardholder_name');
		if (selectedPaymentType === 'sepa') return translate('fe.components.sepa.account_holder_name');
		return translate('fe.components.payments.full_name');
	}, [selectedPaymentType, translate]);

	const placeholder = translate('fe.components.credit_card.name');

	return {
		data: {
			userName,
			nameErrorMessage,
			label,
			placeholder,
		},
		actions: {
			setUserName,
			focusNameInput,
		},
	};
}
